module.exports = __webpack_public_path__ + "img/noCart1.49e0be58.png";